module.exports = __webpack_public_path__ + "static/media/Sonia Liang.931f0c7d.jpg";